@if (client$ | async; as client) {
    <div>
        @if (hosted) {
            <h1>Users</h1>
        } @else {
            <h1>Billing</h1>
        }

        @if (billingInfo$ | async; as billingInfo) {
            <div>
                @if (client.is_paid && !hosted) {
                    <div>
                        <div class="flex row total align-end">
                            <div class="flex flex-30">
                                <mat-chip>
                                    {{ billingInfo.status }}
                                    @if (
                                        billingInfo.cancel_at !== null &&
                                        billingInfo.status === "active"
                                    ) {
                                        <span>
                                            until {{ billingInfo.cancel_at * 1000 | date }}</span
                                        >
                                    }
                                </mat-chip>
                            </div>
                            <div class="flex flex-70 column align-items-end">
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    (click)="customerPortal()"
                                >
                                    Manage Subscription
                                </button>
                            </div>
                        </div>
                        <h3>Billing email: {{ billingInfo.email }}</h3>
                        <h3>Credit card on file: **** **** **** {{ billingInfo.last4 }}</h3>
                        <table class="mat-mdc-table">
                            <thead>
                                <tr
                                    class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row"
                                >
                                    <th
                                        class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-position mat-column-position"
                                    >
                                        Product
                                    </th>
                                    <th
                                        class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-position mat-column-position"
                                    >
                                        Quantity
                                    </th>
                                    <th
                                        class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-position mat-column-position"
                                    >
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="mdc-data-table__content">
                                @for (item of billingInfo.items; track item) {
                                    <tr class="mat-mdc-row mdc-data-table__row cdk-row">
                                        <td
                                            class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-position mat-column-position"
                                        >
                                            {{ item.product }}
                                        </td>
                                        <td
                                            class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-position mat-column-position"
                                        >
                                            {{ item.quantity }}
                                        </td>
                                        <td
                                            class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-position mat-column-position"
                                        >
                                            ${{
                                                (
                                                    (item.quantity * item.unit_amount) /
                                                    100.0
                                                ).toFixed(2)
                                            }}
                                            /
                                            {{ item.interval }}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <mat-divider></mat-divider>
                        <div class="flex row total align-end">
                            <div class="flex-15"><h2>Total</h2></div>
                            <div class="flex-15">
                                <h2>
                                    ${{ total.toFixed(2) }} / {{ billingInfo.items[0].interval }}
                                </h2>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <br />
                        @if (billingInfo.cancel_at === null) {
                            <mat-accordion>
                                <mat-expansion-panel class="warning">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <mat-icon>error_outline</mat-icon>&nbsp; Danger Zone
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    @if (client.is_paid) {
                                        <div>
                                            <div class="flex item">
                                                <h3>Cancel Subscription</h3>
                                                <p>
                                                    Cancel your subscription, this will remove all
                                                    users except the admin and reduce the storage
                                                    limit back to 1GB. If you have more content than
                                                    that, you will be unable to upload new content.
                                                </p>
                                            </div>
                                            <div>
                                                <button
                                                    mat-stroked-button
                                                    color="accent"
                                                    (click)="confirmCancel(client.id)"
                                                >
                                                    Cancel Subscription
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </mat-expansion-panel>
                            </mat-accordion>
                        } @else {
                            <mat-card appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title>Renew Subscription</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p>
                                        Your plan will be canceled on
                                        {{ billingInfo.cancel_at * 1000 | date }}.
                                    </p>
                                </mat-card-content>
                                <mat-card-actions class="flex align-end">
                                    <button
                                        mat-stroked-button
                                        (click)="customerPortal()"
                                        color="primary"
                                    >
                                        Renew Subscription
                                    </button>
                                </mat-card-actions>
                            </mat-card>
                        }
                        <br />
                        <mat-divider></mat-divider>
                        <br />
                    </div>
                }
            </div>
        }
        @if (!hosted) {
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Storage</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    @if (storagePending) {
                        <div>Pending changes</div>
                    } @else {
                        <span
                            >{{ client.storage_use | bytes }} /
                            {{ client.storage_quota | bytes }}</span
                        >
                        <mat-progress-bar
                            mode="determinate"
                            [value]="(client.storage_use / client.storage_quota) * 100"
                        ></mat-progress-bar>
                    }
                    <ng-template #storage>
                        <span
                            >{{ client.storage_use | bytes }} /
                            {{ client.storage_quota | bytes }}</span
                        >
                        <mat-progress-bar
                            mode="determinate"
                            [value]="(client.storage_use / client.storage_quota) * 100"
                        ></mat-progress-bar>
                    </ng-template>
                </mat-card-content>
                <mat-card-actions class="flex align-end">
                    @if (client.is_paid) {
                        <button
                            mat-stroked-button
                            (click)="openStorageDialog(client.id)"
                            color="accent"
                        >
                            Get More Storage
                        </button>
                    } @else {
                        <button mat-stroked-button routerLink="/pricing" color="primary">
                            Upgrade Account
                        </button>
                    }
                </mat-card-actions>
            </mat-card>
            <br />
        }

        <mat-divider></mat-divider>
        <br />
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>Invitations</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list role="list">
                    @for (invitation of client.invitations; track invitation) {
                        <mat-list-item role="listitem">
                            <mat-icon matListItemIcon>mail</mat-icon>
                            <span matListItemTitle [class.expired]="invitation.expired()">{{
                                invitation.email
                            }}</span>
                            <span matListItemLine
                                >Expires on {{ invitation.expires | date: "short" }}</span
                            >
                            <div matListItemMeta>
                                @if (invitation.expired()) {
                                    <button
                                        mat-icon-button
                                        (click)="resendInvitation(invitation.id)"
                                        matTooltip="Resend Invite"
                                    >
                                        <mat-icon>send</mat-icon>
                                    </button>
                                }
                                <button
                                    mat-icon-button
                                    (click)="revokeInvitation(invitation.id)"
                                    matTooltip="Remove Invite"
                                >
                                    <mat-icon>cancel_schedule_send</mat-icon>
                                </button>
                            </div>
                        </mat-list-item>
                    }
                </mat-list>
            </mat-card-content>
            <mat-card-actions class="flex justify-space-between">
                <frog-invite-users-button></frog-invite-users-button>
                <frog-invitation-link></frog-invitation-link>
            </mat-card-actions>
        </mat-card>
    </div>
}

<frog-user-admin></frog-user-admin>
